import { Injectable } from "@angular/core";
import { AvailableProducts, ExportOrganization, OrgProdLineMetadata, ServiceResponse } from "@data/index";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";
import { ResponseHandler } from "@service/system/responseHandler.service";
import { Observable } from "rxjs";

const API_URL = API.API_URL;

@Injectable()
export class ProductExporterService {
	private _serviceURL = `${API_URL}/export`;

	constructor(private httpManager: HttpManager, private responseHandler: ResponseHandler) {}

	getAvailableProducts(orgID: string, format: number): Observable<ServiceResponse<AvailableProducts[]>> {
		const params = { format: format };
		return this.responseHandler.httpGet<AvailableProducts[]>(
			`${this._serviceURL}/org/${orgID}/availableproducts`,
			params
		);
	}

	getExportOrganizations(orgItemID: string): Observable<ServiceResponse<ExportOrganization[]>> {
		return this.responseHandler.httpGet<ExportOrganization[]>(`${this._serviceURL}/org/${orgItemID}/config`);
	}

	getOrgProdLineMetadata(orgItemID: string): Observable<ServiceResponse<OrgProdLineMetadata[]>> {
		return this.responseHandler.httpGet<OrgProdLineMetadata[]>(
			`${this._serviceURL}/org/${orgItemID}/wbtplmetadata`
		);
	}

	getExportPackage(
		courseVersionItemIDs: string,
		orgItemID: string,
		exportFormat: number,
		exportContext: string = "learning",
		cpVersion: string = "",
		cpCompatibility: number = 5
	): any {
		const params = {
			exportFormat: exportFormat,
			exportContext: exportContext,
			cPVersion: cpVersion,
			cpCompatibility: cpCompatibility
		};
		return this.httpManager.httpPostBlob<any>(
			`${this._serviceURL}/org/${orgItemID}/package`,
			courseVersionItemIDs,
			params
		);
	}
}
